
import React from 'react';
import HeroSection from '@/components/about/HeroSection';
import AboutSection from '@/components/about/AboutSection';
import ValuesSection from '@/components/about/ValuesSection';
import LifestyleSection from '@/components/about/LifestyleSection';
import CTASection from '@/components/about/CTASection';
import InterlacedLogoV2 from '@/components/ui/InterlacedLogoV2';

const About = () => {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.8
    }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <div className="relative bg-gradient-to-br from-black via-gray-900 to-black text-white overflow-x-hidden scroll-smooth font-sans min-h-screen flex flex-col">
      {/* Gradiente de fundo luxuoso global */}
      <div className="fixed inset-0 bg-gradient-to-br from-luxury-red/5 via-black to-luxury-purple/5 pointer-events-none"></div>
      <div className="fixed inset-0 bg-gradient-to-t from-luxury-purple/3 via-transparent to-luxury-purple/3 pointer-events-none"></div>
      
      <div className="flex-1">
        <HeroSection
          fadeInUp={fadeInUp}
          staggerContainer={staggerContainer}
        />

        <AboutSection
          fadeInUp={fadeInUp}
          staggerContainer={staggerContainer}
        />

        <ValuesSection
          fadeInUp={fadeInUp}
          staggerContainer={staggerContainer}
        />

        <LifestyleSection
          fadeInUp={fadeInUp}
          staggerContainer={staggerContainer}
        />

        <CTASection
          fadeInUp={fadeInUp}
          staggerContainer={staggerContainer}
        />
      </div>

      {/* Rodapé fixo */}
      <footer className="relative py-8 border-t border-white/10 bg-black/50 backdrop-blur-sm mt-auto">
        <div className="max-w-6xl mx-auto text-center px-4">
          <div className="flex justify-center mb-3">
            <InterlacedLogoV2 variant="horizontal" size="sm" />
          </div>
          <p className="text-white/60 text-sm">
            © 2025 Interlaced. Todos os direitos reservados.
          </p>
          <p className="text-white/40 text-xs mt-1">
            Conexões exclusivas entre sucesso e ambição.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default About;
